import { Component, input, signal, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MenuItem } from '../main-sidenav/sidenav-menu.component';
import { NgStyle } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { SidenavComponent } from '../main-sidenav/sidenav-menu.component';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'pixl-menu-item',
  animations: [
    trigger('expandContractMenu', [
      transition(':enter', [
        style({ opacity: 0, height: '0px' }),
        animate('400ms ease-in-out', style({ opacity: 1, height: '*' }))
      ]),
      transition(':leave', [
        animate('400ms ease-in-out', style({ opacity: 0, height: '0px' }))
      ])
    ])
  ],
  imports: [
    MatListModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    NgStyle,
    TranslocoModule
  ],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss'
})
export class MenuItemComponent implements OnInit {
  private paddingLeft = 14;
  public item = input.required<MenuItem>();
  public collapsed = input(false);
  public nestedMenuOpen = signal(false);
  public subItemCounter = input<number>(0);
  private sidenavComponent = inject(SidenavComponent, { skipSelf: true });

  ngOnInit(): void {
    this.sidenavComponent.openedMenus$.subscribe(openedMenus => {
      const itemRoute = this.item().route;

      if (itemRoute && this.hasChildren(this.item())) {
        const shouldBeOpen = openedMenus.includes(itemRoute);
        this.nestedMenuOpen.set(shouldBeOpen);
      }
    });
  }

  public handleMenuClick(): void {
    if (this.hasChildren(this.item())) {
      this.sidenavComponent.toggleMenu(this.item().route as string);
    }
  }

  public incSubItemCounter(): number {
    return this.subItemCounter() + 1;
  }

  public getPaddingLeft(): string {
    return (this.paddingLeft * this.subItemCounter()).toString() + 'px';
  }

  public showRouterLink(item: MenuItem | undefined): boolean {
    if (!item) {
      return false;
    }
    return !!item.route && item.route.length > 1;
  }

  public hasChildren(item: MenuItem): boolean {
    return !!item && !!item.children && item.children.length > 0;
  }
}
